const {
  applePayConfigService,
  mainConfigService,
  googlePayConfigService,
  samsungPayConfigService,
} = require('./services/config');
const {
  getHtml,
  getSaveCardsHtml,
  getPaymentMethodsHtml,
  getPaymentServicesHtml,
  getCardRemoveModalHtml,
  getFailedModalHtml,
  getButtonsHtml,
  checkSaveCardsExist,
  checkRender,
  getHtmlErorrModal,
  setEventListenerForRadioButtons,
  getApplePayNotSupportedHtml,
  checkFormsofPayments,
  replaceSdk,
  getTotalAmountHtml,
  getCssTheme,
  getPopupModalHtml,
  validateSetupPreload,
  findPaymentConfig,
  handleApplePayStyles,
  handleMobilePayStyles,
  isObjectEmpty,
  isOnlyApplePay,
  getTamaraWidget,
  getInstallmentMethodLabels,
  getTabbyWidget,
  getTalyWidget,
  loadCSS,
  loadExternalCSS,
  preloadFonts,
  handleWalletConfigs,
  sanitizePaymentData,
  normalizeConfig,
  applySplitOrder,
  applyViewToggle,
  getWalletHtml,
} = require('./util');
const { setupSentry, captureError } = require('./sentry');
const { getPaymentDetails, updateTxnStatus } = require('./http');
const { elements, SDK_FOPS, method } = require('./variables');
const {
  _applePayAvailable,
  _startApplePaySession,
  _openAppleWalletApp,
  _isWalletActive,
  loadApplePayJS,
  embedPlaceHolderApplePayButton,
} = require('./apple');
const { Selector } = require('./selector');
const { onGooglePayLoaded } = require('./googlePay');
const { $t } = require('./translate');
const { loadSamsungPay } = require('./samsungPay');
const { CallbackService, FieldsService } = require('./services');
const { handleFlexPaymentMethod } = require('./integrations/BNPLMethods');
const { setupBFCacheReload } = require('./utils/events');
const { termsCheckboxBlock, termsNoticeBlock, pciLogosSection } = require('./html');

Checkout = typeof Checkout === 'undefined' ? {} : Checkout;

const curScriptElement = document.currentScript;
Selector.setCurrentScript(curScriptElement);
let callbackService = undefined;
let fieldsService = undefined;
let isApplePayProcessing = false;

const setEvents = (applePay, isWalletActive, stcPay, urPay) => {
  const payMethods = documentCheckout.querySelectorAll(
    '.' + elements.paymentMethod
  );
  
  const paymentServices = [...payMethods].filter(el => 
    el.getAttribute('data-method_type') === 'payment_service'
  );
  
  const methodFlows = [...paymentServices].map(el => el.getAttribute('name'));
  const firstWalletFlow = methodFlows?.[0];

  const hasDuplicateFirstWallet = methodFlows.filter(
    flow => firstWalletFlow === flow
  ).length > 1;

  const cards = documentCheckout.querySelector('#' + elements.savedCardsBlock);
  let isPrefferedCard = false;
  const isWalletFullCoverage = !!(Selector.walletService && Selector.walletService.isFullCoverage());

  if (!isWalletFullCoverage) {
    if (!paymentServices.length && cards) {
      const savedCards = documentCheckout.querySelectorAll(
        '.' + elements.accordionItemRadio
      );
      savedCards.forEach((element) => {
        if (
          !(element.getAttribute('data-is_expired') === 'true') &&
          element.getAttribute('data-is_preferred') === 'true'
        ) {
          element.checked = true;
          Selector.selectePayMethod(element);
          isPrefferedCard = true;
        }
      });

      if (!isPrefferedCard) {
        if (
          savedCards[0] &&
          savedCards[0].getAttribute('data-is_expired') === 'false'
        ) {
          savedCards[0].checked = true;
          Selector.selectePayMethod(savedCards[0]);
        }
      }
    } else if (payMethods.length === 1) {
      Selector.selectePayMethod(payMethods[0]);
    } else if (!hasDuplicateFirstWallet && paymentServices.length) {
      Selector.selectePayMethod(paymentServices[0]);
    }
  }

  payMethods.forEach((element) => {
    element.addEventListener(
      'click',
      function () {
        Selector.selectePayMethod(this);
      },
      true
    );
  });

  documentCheckout
    .querySelectorAll('.' + elements.accordionItemRadio)
    .forEach((element) => {
      if (!(element.getAttribute('data-is_expired') === 'true')) {
        element.addEventListener(
          'click',
          function () {
            Selector.selectePayMethod(this);
          },
          true
        );
      } else {
        element.disabled = true;
        element.nextElementSibling.
          classList.add('ottu__sdk-disabled');
      }
    });

    // Wallet toggle event listeners
    const walletToggles = documentCheckout.querySelectorAll('.' + elements.walletToggle);
    walletToggles.forEach((toggle) => {
      toggle.addEventListener(
        'change',
        async function () {
          await Selector.walletService.handleToggle(this);
        },
        true
      );
    });

    const payButton = documentCheckout.querySelector('#' + elements.payButton);
    if (payButton) {
      if (!(payMethods.length || cards) || (!method.type && !isWalletFullCoverage)) {
        payButton.classList.add('ottu__sdk-disabled-pay-button');
        payButton.setAttribute('disabled', 'true');
        payButton.removeEventListener('click', Selector.payButtonClick);
      } else {
        payButton.classList.remove('ottu__sdk-disabled-pay-button');
        payButton.removeAttribute('disabled', 'true');
        payButton.addEventListener('click', Selector.payButtonClick);
      }
    }

  if (isWalletFullCoverage) {
    Selector._setOtherMethodsDisabled(true);
  }

  if (documentCheckout.querySelector('#' + elements.payCancel)) {
    documentCheckout.querySelector('#' + elements.payCancel).addEventListener(
      'click',
      function () {
        Selector.cancelButtonClick();
      },
      true
    );
  }

  documentCheckout
    .querySelectorAll('.' + elements.saveCardDeleteButton)
    .forEach((element) => {
      element.addEventListener(
        'click',
        function () {
          const number = this.attributes['data-number'].value;
          const delete_url = this.attributes.delete_url.value;
          const modal = documentCheckout.querySelector('#' + elements.modal);
          Selector.showModal(getCardRemoveModalHtml(number));
          const radioDiv = this.closest('.ottu__sdk-radio-div');
          modal.querySelector('.delete-button').addEventListener(
            'click',
            function () {
              Selector._deleteToken(delete_url, radioDiv);
            },
            true
          );
        },
        true
      );
    });

  if (applePay) {
    documentCheckout
      .querySelector('#' + elements.applePayButton)
      .addEventListener('click', () => {
        // Prevent multiple simultaneous Apple Pay sessions
        if (isApplePayProcessing) {
          return;
        }

        isApplePayProcessing = true;

        callbackService.callBackValidate()
          .then((isValid) => {
            if (isValid === false) {
              isApplePayProcessing = false;
              return; // stop execution if the validate promise rejects;
            }
            if (isWalletActive) {
              _startApplePaySession().finally(() => {
                isApplePayProcessing = false;
              });
            } else {
              _openAppleWalletApp(applePayConfigService.get('merchant_id')).finally(() => {
                isApplePayProcessing = false;
              });
            }
          })
          .finally(() => {
            isApplePayProcessing = false;
          });
      });
  }

  if (stcPay) {
    let stcButton = documentCheckout.querySelector('#' + elements.stcPayButton);
    stcButton.addEventListener(
      'click',() => {
        callbackService.callBackValidate()
          .then((isValid)=>{
            if (isValid === false) {
              return; // stop execution if the validate promise rejects;
            }
            Selector.selectePayMethod(stcButton);
            Selector._mobilePay('stcPay');
          });
      },
      true
    );
  }

  if (urPay) {
    let urPayButton = documentCheckout.querySelector(
      '#' + elements.urPayButton
    );
    urPayButton.addEventListener(
      'click',() => {
        callbackService.callBackValidate()
          .then((isValid)=>{
            if (isValid === false) {
              return; // stop execution if the validate promise rejects;
            }
            Selector.selectePayMethod(urPayButton);
            Selector._mobilePay('urPay');
          })
      },
      true
    );
  }
};

const renderHtml = async () => {
  try {
    // Create a wrapper element for the Shadow DOM
    const parentElement = document.getElementById(mainConfigService.get('selector'));
    const shadowWrapper = document.createElement('div');
    shadowWrapper.id = 'ottu-checkout-shadow-wrapper';
    parentElement.appendChild(shadowWrapper);

    // Attach Shadow DOM to the wrapper instead of directly to mainConfigService.get('selector')
    documentCheckout = shadowWrapper.attachShadow({
      mode: mainConfigService.get('shadowRootClosed') ? 'closed' : 'open'
    });
    Selector.setSelector(documentCheckout);

    await loadCSS(documentCheckout);

    preloadFonts([
      {
        family: 'uae_aed',
        src: `${process.env.SERVER_URL}/v3/fonts/UAE-dirham.woff`,
      },
      {
        family: 'saudi_riyal',
        src: `${process.env.SERVER_URL}/v3/fonts/ae15d335519aad3d21f6.woff2`,
      },
    ]);

    const sdkhtml = document.createElement('div');
    sdkhtml.setAttribute('id', 'ottu-js-sdk');
    sdkhtml.setAttribute('class', mainConfigService.get('lang'));
    sdkhtml.innerHTML = getHtml(mainConfigService.get('displayMode'));

    documentCheckout.appendChild(sdkhtml);
    applySplitOrder(documentCheckout);

    const theme = mainConfigService.get('theme');
    if (!isObjectEmpty(theme)) {
      const overiddenTheme = getCssTheme(theme);
      Selector.injectCSS(overiddenTheme);
    }
  } catch (error) {
    console.log('[Error] While rendering HTML', error.message || '');
  }
};

let documentCheckout;
async function init(configs, reload) {
  // Normalize config to handle Vue proxy objects and other reactive wrappers
  // This must be done first to prevent side effects throughout the SDK flow
  try {
    configs = normalizeConfig(configs);
  } catch (error) {
    captureError(error, {
      message: 'Failed to normalize config during SDK initialization',
      tags: { error_location: 'init_normalize_config' },
    });
    console.error('[Checkout SDK] Config normalization failed:', error.message || '');
  }

  if (
    !document.querySelector(
      "meta[content='width=device-width, initial-scale=1.0']"
    )
  ) {
    const viewportMeta = document.createElement('meta');
    viewportMeta.setAttribute('name', 'viewport');
    viewportMeta.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0'
    );
    document.head.appendChild(viewportMeta);
  }
  
  if (process.env.IS_LOCAL === 'true' || window.location.protocol === 'https:') {
    if (!configs.formsOfPayment) {
      configs = {
        ...configs,
        formsOfPayment: [
          'applePay',
          'tokenPay',
          'ottuPG',
          'redirect',
          'googlePay',
          'stcPay',
          'urPay',
          'jazz',
          'samsungPay',
          'wallet',
        ],
      };
    }

    const valid = mainConfigService.initialize({
      ...configs,
      lang: configs.setupPreload?.language,
      payment_type: configs.setupPreload?.payment_type,
    });
    if (!valid) {
      return false;
    }

    googlePayConfigService.updateConfig({theme: configs.theme?.googlePay || {}});
    applePayConfigService.updateConfig({theme: configs.theme?.applePay || {}});

    if (!document.getElementById(mainConfigService.get('selector'))) {
      console.log(
        `[Error] HTML element with id ${mainConfigService.get('selector')} was not found in the DOM.`
      );
      return;
    } else if (reload) {
      replaceSdk(mainConfigService.get('selector'));
    }
    
    // Cleanup old JazzIntegration instance before reload to prevent stale DOM references
    if (Selector.jazzIntegration) {
      Selector.jazzIntegration.destroy();
      Selector.jazzIntegration = null;
    }

    // Cleanup One Last Check service before reload
    if (Selector.oneLastCheckService) {
      Selector.oneLastCheckService.destroy();
      Selector.oneLastCheckService = null;
    }

    //Initialize Sentry
    if (process.env.IS_LOCAL !== 'true') {
      setupSentry(configs, configs.setupPreload?.sdk_studio);
    }

    await loadExternalCSS();

    if (checkRender(mainConfigService.get('render'))) {
      await renderHtml();


      fieldsService = new FieldsService(Selector.documentCheckout);
      callbackService = new CallbackService(curScriptElement, fieldsService);
      Selector.initializeServices(callbackService, fieldsService);


      const hasOtherPaymentMethods = (
        checkFormsofPayments('tokenPay') ||
        checkFormsofPayments('ottuPG') ||
        checkFormsofPayments('redirect') ||
        checkFormsofPayments('googlePay') ||
        checkFormsofPayments('stcPay') ||
        checkFormsofPayments('urPay') ||
        checkFormsofPayments('samsungPay') ||
        checkFormsofPayments('jazz') ||
        checkFormsofPayments('friendPay')
      );

      if (!hasOtherPaymentMethods) {
        Selector.renderOnlyApplePay();
        documentCheckout = Selector.documentCheckout;
      }

      let data;
      if (
        mainConfigService.get('setupPreload') &&
        validateSetupPreload(mainConfigService.get('setupPreload'))
      ) {
        const rawData = configs.setupPreload;
        handleWalletConfigs(rawData);

        data = sanitizePaymentData(rawData);

        mainConfigService.updateConfig({
          amount: data.amount,
          payment_services: data.payment_services,
          payment_methods: data.payment_methods,
          flex_methods: data.flex_methods,
          cards: data.cards,
          sdk_studio: data.sdk_studio,
        });

        if (rawData?.state === 'created') { 
          try {
            updateTxnStatus(configs.merchant_id, configs.session_id ,configs.apiKey)
          } catch (error) {
            Selector.errorResponse(error)
          }
        }
      } else {
        try {
          const rawData = await getPaymentDetails(
            mainConfigService.get('merchant_id'),
            mainConfigService.get('session_id'),
            mainConfigService.get('apiKey')
          );

          handleWalletConfigs(rawData);


          // Sanitize API response data before using in templates
          data = sanitizePaymentData(rawData);

          mainConfigService.updateConfig({
            amount: data.amount,
            lang: data.language,
            payment_type: data.payment_type,
            payment_services: data.payment_services,
            payment_methods: data.payment_methods,
            flex_methods: data.flex_methods,
            cards: data.cards,
          });
          Selector.translateHeaders(data.language);
        } catch (error) {
          Selector.errorResponse(error);
          return;
        }
      }

      try {
        let html = '';
        let applePay = false;
        let googlePay = false;
        let stcPay = false;
        let urPay = false;
        let samsungPay = false;
        let hasPaymentServiceOptions = false;

        if (configs._studioEnabled) {
          mainConfigService.setSDKStudioConfigs(data.sdk_studio);
        }

        const cancel = mainConfigService.get('displayRejectButton') && data.cancel_url;
        if ((data.payment_services?.length === 1 && !data.payment_methods?.length && !data.flex_methods?.length)){

          const apple_pay_config = findPaymentConfig(
            data.payment_services,
            SDK_FOPS.APPLE_PAY
          );
          if (
            (apple_pay_config || data.apple_pay_available) &&
            checkFormsofPayments('applePay')
          ) {
            try {
              const { appleScriptLoaded } = await loadApplePayJS();
              if (!appleScriptLoaded) {
                embedPlaceHolderApplePayButton();
              }
              applePayConfigService.updateConfig({ isApplePaySDKAvailable: !appleScriptLoaded });
            } catch (error) {
              console.log('Apple Pay SDK failed to load, using fallback:', error);
              applePayConfigService.updateConfig({ isApplePaySDKAvailable: false });
            }

            if (_applePayAvailable()) {
              applePay = true;
              applePayConfigService.updateConfig(apple_pay_config || data.apple_pay_config);
              if (configs.applePayInit) {
                applePayConfigService.updateConfig(configs.applePayInit); //Always keep applePayInit after apple_pay_config so that values can be overwritten
              }

              if(configs._studioEnabled) {
                applePayConfigService.setSDKStudioConfigs(apple_pay_config, data.sdk_studio);
              }
            }
          }

          const google_pay_config = findPaymentConfig(
            data.payment_services,
            SDK_FOPS.GOOGLE_PAY
          );
          if (
            (google_pay_config || data.google_pay_available) &&
            checkFormsofPayments('googlePay')
          ) {
            googlePay = true;
            googlePayConfigService.updateConfig(google_pay_config || data.google_pay_config);
            if (configs.googlePayInit){
              googlePayConfigService.updateConfig(configs.googlePayInit); //Always keep googlePayInit after google_pay_config so that values can be overwritten
            }
          }

          const samsung_pay_config = findPaymentConfig(
            data.payment_services,
            SDK_FOPS.SAMSUNG_PAY
          );
          if (
            samsung_pay_config &&
            checkFormsofPayments('samsungPay')
          ) {
            samsungPay = true;
            samsungPayConfigService.updateConfig(samsung_pay_config);
          }

          if (applePay && checkFormsofPayments('applePay')) {
            const styles = handleApplePayStyles();
            if (styles) {
              Selector.injectCSS(styles);
            }
            var isWalletActive = applePayConfigService.get('merchant_id')
              ? await _isWalletActive()
              : true;
            Selector.setSelector(documentCheckout);
            documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
            Selector.showAppleButton(applePay, isWalletActive);
            documentCheckout = Selector.documentCheckout;
          }

          if (googlePay && checkFormsofPayments('googlePay')) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://pay.google.com/gp/p/js/pay.js';
            script.onload = async function () {
              let button = await onGooglePayLoaded(documentCheckout);
              Selector.showGoogleButton(button);
              documentCheckout = Selector.documentCheckout;
            };
            document.head.appendChild(script);
            documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
          }

          if (samsungPay && checkFormsofPayments('samsungPay')) {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://img.mpay.samsung.com/gsmpi/sdk/samsungpay_web_sdk.js'
            script.onload = async function () {
              let button = await loadSamsungPay();
              Selector.showSamsungButton(button);
              documentCheckout = Selector.documentCheckout;
            };
            document.body.appendChild(script);
            documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
          }

          const stcPayConfig =
            findPaymentConfig(data.payment_services, SDK_FOPS.STC_PAY) ||
            findPaymentConfig(data.payment_methods, SDK_FOPS.STC_PAY);
          if (stcPayConfig && checkFormsofPayments('stcPay')) {
            stcPay = true;
            let styles = handleMobilePayStyles('stcPay');
            Selector.injectCSS(styles);
            documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
            Selector.showStcButton(stcPayConfig);
          }

          const urPayConfig =
            findPaymentConfig(data.payment_services, SDK_FOPS.UR_PAY) ||
            findPaymentConfig(data.payment_methods, SDK_FOPS.UR_PAY);
          if (urPayConfig && checkFormsofPayments('urPay')) {
            urPay = true;
            let styles = handleMobilePayStyles('urPay');
            Selector.injectCSS(styles);
            documentCheckout.querySelector('.wallet-buttons')?.classList.remove('d-none');
            Selector.showUrPayButton(urPayConfig);
          }
        }


        // Tamara configuration
        const tamara_configs = findPaymentConfig(data.flex_methods, SDK_FOPS.TAMARA);
        handleFlexPaymentMethod(Selector, documentCheckout, tamara_configs, {
          onInit: (configs) => {
            window.tamaraWidgetConfig = {
              lang: mainConfigService.get('lang'),
              country: configs.country,
              publicKey: configs.public_key
            };

            let scriptElement = document.createElement('script');
            scriptElement.setAttribute('defer', '');
            scriptElement.setAttribute('type', 'text/javascript');
            scriptElement.setAttribute('src', process.env.TAMARA_CDN);
            document.head.appendChild(scriptElement);
          },
          checkAvailability: (options) => options?.is_available,
          getLabel: (options) => getInstallmentMethodLabels(options),
          getWidget: (label, configs) => getTamaraWidget(label, configs.amount, configs.description)
        })?.finally(() => {
          setEvents(applePay, isWalletActive, stcPay, urPay);
          applyViewToggle(documentCheckout);
        });

        // Tabby configuration
        const tabby_configs = findPaymentConfig(data.flex_methods, SDK_FOPS.TABBY);
        handleFlexPaymentMethod(Selector, documentCheckout, tabby_configs, {
          checkAvailability: (options) => options?.is_available,
          getLabel: () => $t('Pay in 4 interest-free payments'),
          getWidget: (label, configs) => getTabbyWidget(label, configs.icon, configs.description)
        })?.finally(() => {
          setEvents(applePay, isWalletActive, stcPay, urPay);
          applyViewToggle(documentCheckout);
        });

        // Taly configuration
        const taly_configs = findPaymentConfig(data.flex_methods, SDK_FOPS.TALY);
        handleFlexPaymentMethod(Selector, documentCheckout, taly_configs, {
          checkAvailability: (options) =>
            options?.is_available === true ||
            (Array.isArray(options?.is_available) && options.is_available.length > 0),
          getLabel: () => $t('Split your payment with Taly'),
          getWidget: (label, configs) => getTalyWidget(label, configs.icon, configs.description)
        })?.finally(() => {
          setEvents(applePay, isWalletActive, stcPay, urPay);
          applyViewToggle(documentCheckout);
        });

        const saveCard = checkSaveCardsExist(data);
        if (saveCard && checkFormsofPayments('tokenPay')) {
          const saveCardsHtml = getSaveCardsHtml(
            data.cards,
            data.currency_code,
            data.payment_methods,
            data.payment_services
          );
          const saveCards = documentCheckout.querySelector(
            '#' + elements.savedCards
          );
          saveCards.innerHTML = saveCardsHtml;

          try {
            await Selector.embedCVVIframe(data.cards);
          } catch (error) {
            captureError(error, {
              message: 'Failed to embed CVV iframe for saved cards',
              tags: { error_location: 'embed_cvv_iframe' },
            });
            console.log(error);
            const nonCVVCards = data.cards.filter(card => !card.cvv_required);
            const filteredSaveCardsHtml = getSaveCardsHtml(
              nonCVVCards,
              data.currency_code,
              data.payment_methods,
              data.payment_services
            );
            saveCards.innerHTML = filteredSaveCardsHtml;
          }

          setEventListenerForRadioButtons(
            saveCards.querySelectorAll('.ottu__sdk-input-ccv')
          );
        } else {
          documentCheckout
            .querySelector('#' + elements.savedCards)
            .classList.add('d-none');
        }

        if (
          checkFormsofPayments('redirect') ||
          checkFormsofPayments('googlePay') ||
          checkFormsofPayments('applePay') ||
          checkFormsofPayments('ottuPG') ||
          checkFormsofPayments('stcPay') ||
          checkFormsofPayments('urPay') ||
          checkFormsofPayments('samsungPay') ||
          checkFormsofPayments('jazz') ||
          checkFormsofPayments('friendPay')
        ) {
          window.redirectSubmitUrl = data.submit_url;
          documentCheckout
            .querySelectorAll('.' + elements.blockMethodsLoader)
            .forEach(loader => {
              loader.remove();
            });
          html += getPaymentMethodsHtml(
            data.payment_methods,
            data.can_save_card,
            data.currency_code,
            data.flex_methods
          );

          const paymentServicesHTML = await getPaymentServicesHtml(
            data.payment_services,
            !!data.payment_methods?.length,
            !!data.flex_methods?.length,
            data.currency_code
          );

          hasPaymentServiceOptions = !!paymentServicesHTML;

          if (
            !getPaymentMethodsHtml(
              data.payment_methods,
              data.can_save_card,
              data.currency_code,
              data.flex_methods
            ) &&
            !paymentServicesHTML &&
            !(saveCard && checkFormsofPayments('tokenPay'))
          ) {
            documentCheckout
              .querySelectorAll('.card-only-display')
              .forEach((element) => {
                element.style.display = 'none';
              });
            documentCheckout
              .querySelector('#' + elements.blockButtons)
              .classList.add('d-none');
          }

          if (paymentServicesHTML) {
            documentCheckout.querySelector(
              `#${elements.blockServices}`
            ).innerHTML = paymentServicesHTML;
          } else {
            documentCheckout.querySelector(
              `#${elements.blockServices}`
            ).classList.add('d-none');
          }

          if (!(saveCard && checkFormsofPayments('tokenPay')) && !paymentServicesHTML) {
            documentCheckout.querySelector(`#${elements.cardsAndServicesBlock}`).classList.add('d-none');
          }

          documentCheckout.querySelector(
            '#' + elements.blockMethods
          ).innerHTML = html;

          try {
            await Selector.embedCardIframe(data.payment_methods);
          } catch (error) {
            captureError(error, {
              message: 'Failed to embed card iframe for payment methods',
              tags: { error_location: 'embed_card_iframe' },
            });
            console.log(error);
            const jazzDisabledPaymentMethods = data.payment_methods.map(method => ({
              ...method,
              use_as_jazz_sdk: false
            }));
            const fallbackHTML = getPaymentMethodsHtml(
              jazzDisabledPaymentMethods,
              data.can_save_card,
              data.currency_code,
              data.flex_methods
            );
            documentCheckout.querySelector(
              '#' + elements.blockMethods
            ).innerHTML = fallbackHTML;
            mainConfigService.updateConfig({ payment_methods: jazzDisabledPaymentMethods });
          }

          // Populate wallet billing map from API data for all methods
          if (Selector.walletService) {
            Selector.walletService.setWalletBillingMap(
              data.payment_methods || [],
              data.payment_services || [],
              data.flex_methods || []
            );
          }

          // Render wallet cards in the correct container based on display mode
          if (checkFormsofPayments('wallet')) {
            const walletHtml = getWalletHtml(data.payment_services, data.currency_code);
            if (walletHtml) {
              const displayMode = mainConfigService.get('displayMode');
              if (displayMode === 'grid') {
                const walletGridContainer = documentCheckout.querySelector(`#${elements.blockWalletGrid}`);
                if (walletGridContainer) {
                  walletGridContainer.innerHTML = walletHtml;
                  walletGridContainer.classList.remove('d-none');
                  // Ensure the parent block is visible since wallet is inside it
                  documentCheckout.querySelector(`#${elements.cardsAndServicesBlock}`).classList.remove('d-none');
                }
              } else {
                const walletContainer = documentCheckout.querySelector(`#${elements.blockWallet}`);
                if (walletContainer) {
                  walletContainer.innerHTML = walletHtml;
                  walletContainer.classList.remove('d-none');
                }
              }
            }
          }

          // Restore wallet active state if already reserved on the backend
          if (Selector.walletService) {
            const wasRestored = Selector.walletService.restoreReservedState();
            if (wasRestored && Selector.walletService.isFullCoverage()) {
              Selector._setOtherMethodsDisabled(true);
            }
          }
          
        } else {
          documentCheckout
            .querySelector('#' + elements.blockMethods)
            .classList.add('d-none');
        }

        mainConfigService.updateConfig({
          public_key_url: data.public_key_url,
          cancel_url: data.cancel_url,
          customer_phone: data.customer_phone,
        });

        if (data.amount && data.currency_code) {
          documentCheckout.querySelector('#' + elements.totalBlock).innerHTML =
            getTotalAmountHtml();

          // Update payment details amount display using billing structure when available
          Selector.changeTotal('', data.currency_code, data.currency_code, data.amount, '', data.billing);
          mainConfigService.updateConfig({ billing: data.billing });
        }
        documentCheckout
          .querySelector('#' + elements.blockButtonsLoader)
          .remove();

        if (
          (data.payment_methods?.length ||
          data.flex_methods?.length || hasPaymentServiceOptions) &&
          (
            checkFormsofPayments('tokenPay') ||
            checkFormsofPayments('redirect') ||
            checkFormsofPayments('ottuPG') ||
            checkFormsofPayments('googlePay') ||
            checkFormsofPayments('stcPay') ||
            checkFormsofPayments('urPay') ||
            checkFormsofPayments('samsungPay') ||
            checkFormsofPayments('jazz') ||
            checkFormsofPayments('friendPay') ||
            checkFormsofPayments('wallet')
          ) || (saveCard && checkFormsofPayments('tokenPay'))
        ) {
          documentCheckout.querySelector(
            '#' + elements.blockButtons
          ).innerHTML = getButtonsHtml(cancel);

          if (Selector.walletService && Selector.walletService.isFullCoverage() && data.amount && data.currency_code) {
            const walletBilling = Selector.walletService.getWalletServiceBilling();
            const baseBilling = mainConfigService.get('billing') || data.billing;
            const composedBilling = baseBilling
              ? { ...baseBilling, original_amount: walletBilling?.amount || baseBilling.original_amount }
              : walletBilling;
            Selector.changeTotal('', data.currency_code, data.currency_code, data.amount, '', composedBilling);
          }
        } else {
          if (applePay && checkFormsofPayments('applePay')) {
            applePayConfigService.updateConfig(data.apple_pay_config);
            documentCheckout
              .querySelector('#' + elements.blockButtons)
              .classList.add('d-none');
          } else if (isOnlyApplePay(data) && !_applePayAvailable()) {
            documentCheckout.querySelector(
              '#' + elements.blockButtons
            ).innerHTML = getApplePayNotSupportedHtml();
            documentCheckout
              .querySelector('#' + elements.blockButtons)
              .classList.remove('d-none');
          }
        }

        // Render terms and conditions section
        const termsConfig = mainConfigService.get('termsAndConditions');
        let termsNoticeHtml = '';
        if (termsConfig.enabled) {
          if (termsConfig.required) {
            const termsSectionEl = documentCheckout.querySelector('#' + elements.termsSection);
            if (termsSectionEl) {
              termsSectionEl.innerHTML = termsCheckboxBlock(termsConfig.url);
              termsSectionEl.classList.remove('d-none');
            }
          } else {
            termsNoticeHtml = termsNoticeBlock(termsConfig.url);
          }
        }

        // Render PCI logos section
        const pciSectionEl = documentCheckout.querySelector('#' + elements.pciSection);
        if (pciSectionEl) {
          const pciLogosHtml = mainConfigService.get('displayPciLogos') ? pciLogosSection() : '';
          pciSectionEl.innerHTML = termsNoticeHtml + pciLogosHtml;
          pciSectionEl.classList.remove('d-none');
        }

        // Apply view toggle for split layout (show more/less for long lists)
        applyViewToggle(documentCheckout);

        // Hide skeleton loaders after all payment configs and UI elements are rendered
        documentCheckout
          .querySelectorAll('.skeleton-loader')
          .forEach((element) => {
            element.style.display = 'none';
          });

        setEvents(applePay, isWalletActive, stcPay, urPay);
      } catch (error) {
        Selector.errorResponse(error);
      }
    }
    
    // Setup BFCache reload after successful initialization
    if (!reload) {
      setupBFCacheReload(() => init(mainConfigService.getConfig(), true));
    }
  } else {
    documentCheckout = document
      .getElementById(configs.selector)
      .attachShadow({ mode: 'closed' });
    Selector.setSelector(documentCheckout);
    const css =
      '<link href="' +
      process.env.SERVER_URL +
      '/v3/css/checkout.css" type="text/css" rel="stylesheet" media="screen,print"></link>';
    documentCheckout.innerHTML = css + getHtmlErorrModal();
    Selector.showModal(
      getFailedModalHtml("Website doesn't run on non https pages", $t('Error')),
      null,
      'info'
    );
  }
}

function reload() {
  init({...mainConfigService.getConfig()}, true);
}

function showPopup(type, message, response) {
  if ((type && type == 'error') || type == 'success' || type == SDK_FOPS.REDIRECT) {
    if (!response) {
      Selector.showModal(
        getPopupModalHtml(type, message || 'Something Went Wrong.'),
        null,
        'info'
      );
    } else {
      Selector.showModal(
        getPopupModalHtml(type, message, response),
        null,
        'info'
      );
    }
  } else {
    Selector.showModal(
      getFailedModalHtml(
        'Please specify a valid type in Checkout.showPopup()',
        $t('Error')
      ),
      null,
      'info'
    );
  }
}

exports.pay = Selector.pay;
exports.init = init;
exports.reload = reload;
exports.showPopup = showPopup;
